import { X_GRIDS, Y_GRIDS } from '../../configs/Battle';

// Check if a tile is occupied
export function isTileOccupied(posX, posY) {
  return this.heros.some((hero) => hero.posX === posX && hero.posY === posY);
}

// Get isometric position of any isoSprite
export function getIsoPosition(isoSprite) {
  const {
    _isoPosition: { x: isoPosX, y: isoPosY },
  } = isoSprite;
  return { isoPosX, isoPosY };
}

// Get target hero from a tile isoSprite
export function getTargetHero(tileSprite) {
  const { isoPosX, isoPosY } = getIsoPosition(tileSprite);
  return this.heros.find((hero) => {
    const { isoPosX: heroIsoPosX, isoPosY: heroIsoPosY } = getIsoPosition(
      hero.isoSprite,
    );
    return heroIsoPosX === isoPosX && heroIsoPosY === isoPosY;
  });
}

// Check if a target hero is dead
export function isTargetHeroDead(hero) {
  const { id } = hero;
  return this.deadHeros.find((deadHero) => deadHero.id === id);
}

// Check if two heros are at same team
export function isSameTeam(hero, opponentHero) {
  return hero.team === opponentHero.team;
}

// Get random position of an unoccupied tile
export function getRandomUnoccupiedPosition() {
  let isOccupied = true;
  let posX;
  let posY;

  while (isOccupied) {
    posX = Math.floor(Math.random() * X_GRIDS);
    posY = Math.floor(Math.random() * Y_GRIDS);
    isOccupied = isTileOccupied.call(this, posX, posY);
  }

  return { posX, posY };
}

// Reset scene data
export function resetData() {
  this.movingHero = null;
  this.availableMoveTiles = [];
  this.availableAttackTiles = [];
  this.isMovable = false;
  this.commandButtons = null;
}
